export default "__VITE_ASSET__6e58967f__"